import { LUDUM_USER_STATUSES } from '@/constants';
const { APPROVED, INVITED, ONBOARDING } = LUDUM_USER_STATUSES;
import { isAthlete } from '@/helpers/rolesHelper';
import get from 'get-object-path';

export const profileGeneral = {
    namespaced: true,

    state: {
        athleteDetails: null
    },

    getters: {
        athleteDetails(state) {
            return state.athleteDetails;
        },

        userRoleId(state) {
            return get(state.athleteDetails, 'roles.data[0].id');
        },

        userIsAthlete(state, getters) {
            return isAthlete(getters.userRoleId);
        },

        userStatusId(state) {
            return get(state.athleteDetails, 'status.data.id');
        },

        userHasActiveStatus(state, getters) {
            return [APPROVED, INVITED, ONBOARDING].includes(getters.userStatusId);
        }
    },

    mutations: {
        saveAthleteDetails(state, athleteDetails) {
            state.athleteDetails = athleteDetails;
        }
    },

    actions: {
        getAthleteDetails(context, profileId) {
            if (!profileId) return;
            return context
                .dispatch(
                    'get',
                    {
                        url: `${api}athlete-details/${profileId}`,
                        params: {
                            club_id: context.rootGetters.selectedClubId,
                            include: [
                                'roles',
                                'user:fields(id|first_name|last_name|full_name|picture|hr_zones|max_hr)'
                            ].join(',')
                        }
                    },
                    {
                        root: true
                    }
                )
                .then(({ data }) => {
                    context.commit('saveAthleteDetails', data);
                    return data;
                })
                .catch(error => {
                    context.commit('saveAthleteDetails', null);
                    return error;
                });
        }
    }
};

export default profileGeneral;
